import { Component, Input, OnInit } from '@angular/core';
import { AppletService } from 'blg-akaun-ts-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SubSink } from 'subsink2';
import { animateText } from '../../modules/layout/animations/animations';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-applet-logo',
  templateUrl: './applet-logo.component.html',
  styleUrls: ['./applet-logo.component.scss'],
  animations: [animateText]
})
export class AppletLogoComponent implements OnInit {

  @Input() opened: boolean;
  @Input() appletName: string;
  @Input() logoBgColor$: Observable<{background: string}>;

  private subs = new SubSink();

  src$: Observable<string>;
  myImage;
  customBg = {
    background: 'mediumslateblue'
  };

  constructor(private appletService: AppletService) {
    this.src$ = this.appletService.getByGuid(sessionStorage.getItem('appletGuid'), AppConfig.apiVisa).pipe(
      map(a => `${environment.api_domain}core2/platform/dm/applets/public/file/applet-icon/${a.data.bl_applet_hdr.applet_icon_file_guid}`)
    );
  }

  ngOnInit() {
    //this.myImage = localStorage.getItem('logo');
    // this.subs.sink = this.logoBgColor$.subscribe({next: resolve => {
    //   this.customBg.background = resolve;
    // }});
  }
}
